import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnblock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unblock, unban"><path d="M5.5 18.5L10 14" stroke="currentColor" strokeWidth="1.5"/><path d="M14 10L18.5 5.5" stroke="currentColor" strokeWidth="1.5"/><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUnblock;
